import React, { useState } from 'react';
import ChevronDownIcon from './icons/ChevronDownIcon';
import ChevronUpIcon from './icons/ChevronUpIcon';

interface MigrationsPanelProps {
    title: string;
    children: React.ReactNode;
    defaultOpen?: boolean;
}

const MigrationsPanel: React.FC<MigrationsPanelProps> = ({
    title,
    children,
    defaultOpen = false,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 overflow-hidden">
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                className="w-full flex items-center justify-between gap-3 px-4 py-3 text-start hover:bg-slate-100/80 dark:hover:bg-slate-800/80 transition-colors"
                aria-expanded={isOpen}
            >
                <span className="text-[10px] font-black uppercase tracking-widest text-slate-600 dark:text-slate-300">
                    {title}
                </span>
                {isOpen ? (
                    <ChevronUpIcon className="w-4 h-4 shrink-0 text-slate-400" />
                ) : (
                    <ChevronDownIcon className="w-4 h-4 shrink-0 text-slate-400" />
                )}
            </button>
            {isOpen && (
                <div className="px-4 pb-4 pt-1 flex flex-wrap gap-2 border-t border-slate-200/80 dark:border-slate-700/80">
                    {children}
                </div>
            )}
        </div>
    );
};

export default MigrationsPanel;
